module.exports = __webpack_public_path__ + "fepro/img/nft_list_bg_t.31473cc1.png";